__turbopack_context__.v({
  "root": "C8omxq_root",
});
